import Component from 'flarum/common/Component';
import Switch from 'flarum/common/components/Switch';
export default class BirthdayPrivacySwitch extends Component {
  loading = false;
  view(vnode) {
    const {
      user,
      attribute
    } = this.attrs;
    return m(Switch, {
      state: !!user[attribute](),
      loading: this.loading,
      onchange: this.save.bind(this)
    }, vnode.children);
  }
  save(value) {
    this.loading = true;
    this.attrs.user.save({
      [this.attrs.attribute]: value
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('datlechin-birthdays', 'forum/components/BirthdayPrivacySwitch', BirthdayPrivacySwitch);